import { GET_VERSION } from '../Constants'
import { requestForServer } from '../Utils/ServerUtil'
import { isLocalhost } from '../fhg/utils/Utils'
import { registerServiceWorkerPromise } from '../index'

// Version checking interval configuration
export const MAX_INTERVAL =
    window.location.hostname === 'dev3.heavyworth.com'
        ? 2 * 61 * 1000
        : isLocalhost
          ? Number.MAX_SAFE_INTEGER - 1
          : 5 * 60 * 1000

// Version checking logic
export const checkVersions = async (currentVersion, onVersionMismatch) => {
    if (!isLocalhost) {
        const result = await requestForServer(
            GET_VERSION.format({ domain: window.location.hostname }),
            'get'
        )
        // No results should be a local build. Should have a version for a released version.
        if (result && result.data && result.data.length >= 1) {
            if (currentVersion !== result.data[0].version) {
                onVersionMismatch(result.data[0].version)
                console.log(
                    `Versions do not match. Current version - ${currentVersion}. New Version - ${result.data[0].version}`
                )
            }
        }
    }
}

// Service worker update logic
export const updateServiceWorkers = () => {
    if (navigator.serviceWorker) {
        navigator.serviceWorker
            .getRegistrations()
            .then((registrations) => {
                for (const registration of registrations) {
                    registration.update()
                }
            })
    }
}

// Initialize version checking with service worker updates
export const initializeVersionChecking = (checkVersionsCallback, currentVersion, onVersionMismatch) => {
    if (!isLocalhost) {
        const interval = setInterval(() => {
            checkVersionsCallback()
            updateServiceWorkers()
        }, MAX_INTERVAL)

        registerServiceWorkerPromise.then((result) => {
            console.log(
                `Service worker is updating. Current version - ${currentVersion}.`
            )
            checkVersionsCallback()
        })

        return interval
    }
    return null
}